import Header from './header';

import { translate as t } from 'utils/i18n';
import { Button, ButtonContainer, Container, WelcomeContainer, WelcomeText } from './styles';
import { MenuModalItemIcon } from '../common/styles';
import { useEffect, useRef, useState } from 'react';
import { scrollIntoView } from 'utils/dom';

export default function Red(props) {
  const containerRef = useRef(null);
  const [center, setCenter] = useState(true);

  useEffect(() => {
    if (!center) {
      scrollIntoView('.main-menu-button', props.focusedIndex);
    }
  }, [center, props.focusedIndex, props.mainMenuList]);

  useEffect(() => {
    setTimeout(() => {
      const el = containerRef.current;
      if (!el) return;
      setCenter(el.scrollWidth <= el.clientWidth);
    }, 100);
  }, [props.mainMenuList]);

  return (
    <Container style={{ direction: props.isRTL ? 'rtl' : 'ltr' }}>
      <Header />
      {props.customerData?.guest_name && (
        <WelcomeContainer isRTL={props.isRTL}>
          <WelcomeText>
            {t('WelcomeNote.welcome')} {props.customerData?.guest_name ?? ''}
          </WelcomeText>
        </WelcomeContainer>
      )}
      <ButtonContainer ref={containerRef} center={center} className='barless-scroll-container'>
        {(props.mainMenuList ?? []).map((item, index) => (
          <Button
            className='main-menu-button'
            key={item.id}
            onClick={() => props.updateMenuList(index, true, true)}
            active={item.active}
            ref={(el) => {
              if (index === props.focusedIndex && el) el.focus();
            }}
          >
            <MenuModalItemIcon active={item.active}>
              <i className={item.icon}></i>
            </MenuModalItemIcon>
            {item.title}
          </Button>
        ))}
      </ButtonContainer>
    </Container>
  );
}
